import { render, staticRenderFns } from "./PurchaseYtdPurchaseNumberDisplayer.vue?vue&type=template&id=09da3350"
import script from "./PurchaseYtdPurchaseNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./PurchaseYtdPurchaseNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports